import React, { useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import cx from 'classnames';
import css from '../dropdown.module.scss';
import { popUpTransitionClasses } from '../../../../../../styles/transitionStyles/transitionStyles';
import { TagsScrollSearchList } from '../list/TagsScrollSearchList';
import { useSelectedGroupTags } from '../../../libs/useSelectedGroupTags';
import { ITemplateGroupTag } from '../../../../../../entities/template/private-template-tag-group/model/types/types';
import { CreateFirstTagPopup } from '../create-first-tag';
import useCatchEnterClick from '../../../../../../hooks/useCatchEnterClick';
import {
	GroupTagsSearchBar,
} from '../../../../../../components/pages/features/templateGroupTag/groupTagsDropdown/searchGroupTagsBar';
import { usePrivateTemplateTags } from './hooks/usePrivateTemplateTags';
import { usePrivateTemplateGroupTags } from './hooks/usePrivateTemplateGroupTags';
import { TagCreationForm } from '../tag-creation-form';
import { TagGroupType } from '../../../../../../entities/template/private-template-tag-group/model/types';

interface IPrivateTagsScrollSearchDropdownProps {
	groupId: string | undefined,
	tagsWithoutGroups: ITemplateGroupTag[] | undefined,
}

export const PrivateTagsScrollSearchDropdown = React.forwardRef<HTMLDivElement, IPrivateTagsScrollSearchDropdownProps>(({
	groupId,
	tagsWithoutGroups,
}, _) => {
	const [search, setSearch] = useState('');
	const containerRef = useRef<HTMLDivElement>(null);

	const { tagsData } = usePrivateTemplateGroupTags(groupId);

	const {
		allTags,
		tagName,
		filteredTags,
		bindCreatedTag,
		handleCreateTag,
		onTagNameChange,
	} = usePrivateTemplateTags(groupId, tagsData, tagsWithoutGroups, search);

	const {
		onSelectTag,
		selectedTags,
		onCleanSelectedGroupTags,
	} = useSelectedGroupTags();

	useCatchEnterClick(handleCreateTag, tagName.length >= 2);

	const hasTags = allTags && allTags.length > 0;

	if (!hasTags) {
		return <CreateFirstTagPopup groupId={groupId} bindCreatedTag={bindCreatedTag} />;
	}

	return (
		<CSSTransition
			timeout={0}
			unmountOnExit
			nodeRef={containerRef}
			in={!!groupId || groupId === TagGroupType.tagsWithoutGroup}
			classNames={popUpTransitionClasses}
		>
			<div className={css.wrapper} ref={containerRef}>
				{/* Поиск по тегам в группе */}
				<GroupTagsSearchBar
					search={search}
					setSearch={setSearch}
					createTag={bindCreatedTag}
				/>

				{
					hasTags
						? (
							<TagsScrollSearchList
								search={search}
								setSearch={setSearch}
								tags={filteredTags || []}
								onSelectTag={onSelectTag}
								currentIds={selectedTags}
								onCreateTag={bindCreatedTag}
							/>
						)
						: <div className={css.not_found}>Тегов не найдено...</div>
				}
				<TagCreationForm
					tagName={tagName}
					onTagNameChange={onTagNameChange}
					handleCreateTag={handleCreateTag}
				/>
				<div
					className={cx(css.reset_group, { [css.focus]: selectedTags.length > 0 })}
					role="presentation"
					onClick={() => onCleanSelectedGroupTags(groupId)}
				>
					Сбросить группу
				</div>
			</div>
		</CSSTransition>
	);
});
